import { SipNumberResponse } from "../../model/sipNumberResponse";
import { SelectOptionsType } from "../../utils/select-helpers";
import { fetchGetJSON } from "../api-helpers";
import { apiUrls } from "../constants";

type DtoType = SipNumberResponse;

type FetchResponseType = {
  data?: DtoType[];
  error?: string;
};

export type TransformedDataType = DtoType;

export type GuiResponseType = {
  data?: SelectOptionsType[];
  error?: string;
};

export async function getSipNumbers_Filtered(): Promise<GuiResponseType> {
  try {
    const url = apiUrls.getSipNumbersData;
    const response: FetchResponseType = await fetchGetJSON(url);
    if (response.error) {
      return { error: response.error };
    } else if (response.data) {
      const xResponseData = response.data
        .filter(
          (sipNumber) =>
            !(
              sipNumber.sipUserAssignmentId ||
              sipNumber.sipOtherAssignmentId ||
              sipNumber.sipMeetingRoomAssignmentId ||
              sipNumber.lastError ||
              sipNumber.sipStatus.name !== "Unassigned"
            )
        )
        .sort((a, b) => {
          return a.phoneNumber - b.phoneNumber;
        })
        .map((sipNumber) => {
          return {
            title: "",
            value: `${sipNumber.id}`,
            label: `${sipNumber.phoneNumber}`,
          };
        });

      return { data: xResponseData };
    }
    return { error: "invariant violation" };
  } catch (err) {
    console.error("Error getSipNumbers_Filtered:%o", err);
    return { error: (err as Error).message };
  }
}
